import { Record } from 'immutable';
import { MISSING_SCOPE } from 'automation-ui-permissions/feature-permissions/constants/DisabledReasons';
export const ACCESS = 'access';
export const REASON = 'reason';
export default class FeaturePermission extends Record({
  [ACCESS]: false,
  [REASON]: MISSING_SCOPE
}, 'FeaturePermission') {
  getHasAccess() {
    return this.get(ACCESS) === true;
  }
  getReason() {
    return this.get(REASON);
  }
}